import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/components/contexts/AuthContext";
import usePermissions from "@/hooks/util/use-permissions";
import { UserPermissionsEnum } from "@t/UserPermissionsEnum";

interface ProtectedRouteProps {
    children: React.ReactNode;
    userRole?: number;
    permission?: UserPermissionsEnum;
}

function ProtectedRoute({ children, userRole = 0, permission }: ProtectedRouteProps) {
    const { authState, isLoggingOut } = useAuth();
    const { hasPermission } = usePermissions();
    const location = useLocation();
    const redirectTo = `${location.pathname}${location.search}`;

    if (authState.token === "" || authState.user?.userId == 0) {
        const redirectUri = encodeURIComponent(redirectTo);
        const url =
            redirectTo === "/" || isLoggingOut ? `/login` : `/login?redirect=${redirectUri}`;
        return <Navigate to={url} />;
    }
    if (authState.user?.userRole < userRole || (permission != null && !hasPermission(permission))) {
        return <Navigate to="/" />;
    }

    return <>{children}</>;
}

export default ProtectedRoute;
